'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// For internal use in WinresReservationPassengerInfo
var PassengerFieldsController = function () {
    function PassengerFieldsController($scope, $timeout) {
        _classCallCheck(this, PassengerFieldsController);

        this.$scope = $scope;
        this.$timeout = $timeout;
    }

    _createClass(PassengerFieldsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getFieldVisibility()
            // getPassengerFields()
            // getPassengerFieldSettings()

            this.data = this.winresReservationContext.getContext();

            this.$scope.$watch('$ctrl.passenger', function () {
                _this.validate();
            }, true);
        }
    }, {
        key: 'getFieldVisibility',
        value: function getFieldVisibility(name) {
            var visibility = this.passenger.FieldVisibility ? this.passenger.FieldVisibility[name] : null;

            // Infant hidden fields
            if (this.passenger.IsInfant && (name == 'Email' || name == 'TelephoneNo' || name == 'MobileNo')) return 'hidden';

            // Child and infant default BirthDate
            if ((this.passenger.IsChild || this.passenger.IsInfant) && name == 'BirthDate') {
                return 'required';
            }

            if (name == 'PostalNumber' && !visibility) {
                return this.winresReservationContext.getFieldVisibility('PostAddress');
            }

            if (!visibility) {
                return this.winresReservationContext.getFieldVisibility(name);
            } else {
                return visibility;
            }
        }
    }, {
        key: 'isFieldVisible',
        value: function isFieldVisible(name) {
            return this.getFieldVisibility(name) !== 'hidden';
        }
    }, {
        key: 'isFieldReadonly',
        value: function isFieldReadonly(name) {
            return this.getFieldVisibility(name) === 'readonly';
        }
    }, {
        key: 'isFieldRequired',
        value: function isFieldRequired(name) {
            return this.getFieldVisibility(name) === 'required';
        }
    }, {
        key: 'getFieldWidth',
        value: function getFieldWidth(fieldName) {
            if (!this.fieldWidths || !this.fieldWidths[fieldName]) {
                return 4;
            }
            return this.fieldWidths[fieldName];
        }
    }, {
        key: 'getFieldsInOrder',
        value: function getFieldsInOrder() {
            var _this2 = this;

            if (this.fields != null) {
                return this.fields;
            }
            if (this.firstField != '') {
                this.fields = this.winresReservationContext.getPassengerFields();
                // move the specified field(s) to be the first

                var firstFields = this.firstField.split(',');

                _.each(firstFields, function (field) {

                    var toBeTheFirstField = _.find(_this2.fields, { Name: field });
                    _.remove(_this2.fields, { Name: field });
                    _this2.fields.unshift(toBeTheFirstField);
                });

                // to remove a field i.e. PostalNumber
                var removeFields = this.removeField.split(',');
                _.each(removeFields, function (field) {
                    _.remove(_this2.fields, { Name: field });
                });
                return this.fields;
            } else {
                if (this.removeField != null) {
                    this.fields = this.winresReservationContext.getPassengerFields();
                    this.removeFields = this.removeField.split(',');
                    _.each(removeFields, function (field) {
                        _.remove(fields, { Name: field });
                    });
                    return this.fields;
                } else {
                    return this.winresReservationContext.getPassengerFields();
                }
            }
        }
    }, {
        key: 'validate',
        value: function validate() {
            var _this3 = this;

            this.$timeout(function () {
                if (!_this3.form) {
                    _this3.errors = [];
                    return;
                }

                _this3.errors = _.uniqBy(_.flatMap(_this3.form.$error, function (controls, validatorName) {
                    return _.map(controls, function (control) {
                        var title = '$t(reservation_customer.' + control.$name + ')';
                        var settings = _this3.winresReservationContext.getPassengerFieldSettings()[control.$name];
                        if (settings && settings.Title) {
                            title = settings.Title;
                        }
                        if (_this3.useAttendee === "true") {
                            var msg = 'kk.error_field';
                        } else {
                            var msg = 'reservation_passenger.error_field';
                        }

                        return {
                            Message: msg,
                            Params: {
                                number: _this3.passengerNumber,
                                field: title
                            } };
                    });
                }), '$name');
            });
        }
    }]);

    return PassengerFieldsController;
}();

PassengerFieldsController.$inject = ['$scope', '$timeout'];

_module3.default.component('passengerFields', {
    template: require('./passengerFields.html'),
    controller: PassengerFieldsController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        fieldWidths: '<',
        passenger: '=',
        passengerNumber: '<',
        errors: '=',

        //changes this field to be the first field displayed, if multiple separate with comma without spaces. Last specified will be first to displayed
        firstField: '@',

        removeField: '@',
        aloneRow: '@',

        // if true: displays attendee instead of traveller
        useAttendee: '@',

        // Countries shown first in country selection. First country in list is set to passenger.
        // Seperate countries by comma ex. "FI,SE,RU"
        countryOrder: '@',

        // List only ETA countries
        etaCountries: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/passengerFields/passengerFields.js
// module id = 274
// module chunks = 2